var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"layout_chidT"},[_vm._v("用户转化数据")]),_c('chart-block',{ref:"chart"}),_c('div',{staticClass:"layout_chidT",staticStyle:{"margin-top":"10px"}},[_vm._v("实时访问数据")]),_c('div',{staticStyle:{"margin-left":"-10px"}},[_c('chart-block',{ref:"chart1"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }